/**
 * IP-15968: iOS Assistant uses a single continuous conversation across all
 * screens. Page context updates change what the assistant knows about the
 * current screen without resetting the active thread. Scope-per-entity
 * (IP-14597) was reverted because technicians expect one persistent thread,
 * not a new conversation per screen.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function conversationScopeForPageContext(_context) {
    return undefined;
}
